import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Grid,
} from "@mui/material";
import { ChargeLine } from "./types";

interface FamilyPlanningProps {
  epsdt: string;
  family_planning: boolean;
  onChange: (field: keyof ChargeLine, value: string | boolean) => void;
  claimStatus: string;
}

const FamilyPlanning: React.FC<FamilyPlanningProps> = ({
  epsdt,
  family_planning,
  onChange,
  claimStatus,
}) => {
  return (
    <Grid container spacing={2} alignItems="center" sx={{ minHeight: "160px" }}>
      <Grid item xs={6.5}>
        <Box>
          <Typography
            sx={{
              color: "#A29D9B",
              fontSize: "12px",
              lineHeight: "26px",
              fontWeight: 700,
            }}
          >
            Key Details
          </Typography>
          <p
            style={{
              color: "#707070",
              fontSize: "10px",
              lineHeight: "14px",
              fontWeight: 400,
              marginBlockStart: "0px",
              marginBlockEnd: "0px",
            }}
          >
            Early and Periodic Screening, Diagnostic, and Treatment is a
            Medicaid Program. If this patient is enrolled, you'll need to
            indicate the modifier and if it's related to family planning.{" "}
            <b>This is uncommon.</b>
          </p>
        </Box>
      </Grid>

      <Grid item xs={5.5}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              width: "28%",
            }}
          >
            <InputLabel
              htmlFor="epsdt"
              sx={{
                color: "#A29D9B",
                fontWeight: 700,
                fontSize: "12px",
                lineHeight: "26px",
              }}
            >
              EPSDT*
            </InputLabel>
            <Box className="field-container" sx={{ marginLeft: "0px" }}>
              <TextField
                id="epsdt"
                size="small"
                value={epsdt}
                variant="outlined"
                placeholder="XX"
                className="the-field"
                required
                autoComplete="off"
                disabled={
                  claimStatus === "submitted" ||
                  claimStatus === "pending_submission"
                }
                onChange={(e) => onChange("epsdt", e.target.value)}
                sx={{
                  width: "100% !important",
                }}
                slotProps={{
                  htmlInput: {
                    maxLength: 2,
                  },
                }}
              />
            </Box>
          </Box>

          <FormControl>
            <FormLabel
              style={{
                color: "#A29D9B",
                fontSize: "12px",
                lineHeight: "26px",
                fontWeight: 700,
                marginBottom: "10px",
              }}
            >
              Family Planning?
            </FormLabel>
            <RadioGroup
              row
              value={family_planning ? "yes" : "no"}
              onChange={(e) =>
                onChange("family_planning", e.target.value === "yes")
              }
              sx={{ display: "flex", columnGap: "10px" }}
            >
              <FormControlLabel
                value="yes"
                disabled={
                  claimStatus === "submitted" ||
                  claimStatus === "pending_submission"
                }
                control={
                  <Radio
                    sx={{
                      p: 0,
                      "& .MuiSvgIcon-root": {
                        fontSize: 16,
                        marginRight: "5px",
                      },
                    }}
                  />
                }
                label="Yes"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                    color: "#1E1E1E",
                  },
                  marginLeft: "0px",
                }}
              />
              <FormControlLabel
                value="no"
                disabled={
                  claimStatus === "submitted" ||
                  claimStatus === "pending_submission"
                }
                control={
                  <Radio
                    sx={{
                      p: 0,
                      "& .MuiSvgIcon-root": {
                        fontSize: 16,
                        marginRight: "5px",
                      },
                    }}
                  />
                }
                label="No"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                    color: "#1E1E1E",
                  },
                }}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FamilyPlanning;
